export default __webpack_public_path__ + "static/media/logo.98e62d28.png";